module.exports = __webpack_public_path__ + "static/media/web_corkboard_photo_akhmetshin.9afcdcc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web_corkboard_photo_akhmetshin.jpg
// module id = 494
// module chunks = 0